

const APP_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? "http://localhost:5006"
    : "https://staxapp.superweb.rs";

export function server(path) {
    if (path.startsWith("/")) path = path.substring(1);
    return `${APP_URL}/${path}`;
}

export function image(image) {
    if(!image) return '';
    const folder = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? '' : 'storage/';
    return `${APP_URL}/${folder}${image.bucket}/${image.name}`;
}